export default __webpack_public_path__ + "static/media/VargaMarikaImg.c95245a1.jpg";